import { render } from "./styleLoader.vue?vue&type=template&id=41cc165a"
import script from "./styleLoader.vue?vue&type=script&lang=js"
export * from "./styleLoader.vue?vue&type=script&lang=js"
script.render = render

export default script